// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "_bundle." + {"4":"fc892e834aaa2a490540","78":"7baab6a977d5e07c7d3e","593":"b8c96bed2e3c68456c76","765":"e47b03b4960d38311fb1","839":"8a77f85223077cee264a","919":"294854153217651c6ad1"}[chunkId] + ".js";
};